export enum recruitmentsDeleteTypes {
  FETCH_RECRUIMENTS_DELETE_REQUEST = "FETCH_RECRUIMENTS_DELETE_REQUEST",
  FETCH_RECRUIMENTS_DELETE_SUCCESS = "FETCH_RECRUIMENTS_DELETE_SUCCESS",
  FETCH_RECRUIMENTS_DELETE_FAILURE = "FETCH_RECRUIMENTS_DELETE_FAILURE",
}